import React, { useState, useRef, useEffect } from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge, Modal,ModalHeader, ModalBody,Table,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useSelector , useDispatch} from 'react-redux'
import ReactTables from "./FeaturesList";
import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
    floattest, numtest} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'
import Switch from "react-bootstrap-switch";
import Select from "react-select";
import dp from "../../images/fet.png"

//import { areaFetch, featureFetch} from "../../../../actions/actions"

import { areaFetch, featureFetch} from "../../../actions/actions"
import { validate } from "json-schema";
function Features(props) {
 var dispatch = useDispatch()
    const hiddenFileInput = useRef(null);
  //  const storfeature  = useSelector(state => state.featureStore.featureData)
    const catlist  = useSelector(state => state.featureStore.featureData).map(x => {
    return {
          label :x.categoryName.en  , value : x.categoryCode, 
          labelfr : x.categoryName.fr, labelar : x.categoryName.ar,
          features : x.features, unit : x.unit
        }
      })

   
    const [features, setFeatures] = useState({featureCode : "", en : "", fr : "", ar : "", unit : "", fib : false})
    const [categories, setCategories] = useState({categoryCode : "", en : "", fr : "", ar : ""})
    const [featuresList, setFeatureslist] = useState([])
    const [alert, setAlert] = React.useState(null);
    const [showvr, setShowvr] = useState(false)
    const [selectedfvrl, setSelectedfvrl] = useState({})
    const [fvrl, setFvrl] = useState([]) 
    const [showProcessing , setShowProcessing] = useState(false)
    
    const [valrange, setValRange] = useState({vrid : "", len : "", lfr : "", lar : "", hen : "", hfr :"", har : ""})
    const dvalrange = [{vrid : "0", len : "0", lfr : "false", lar : "", hen : "", hfr :"", har : ""},{vrid : "1", len : "1", lfr : "false", lar : "", hen : "", hfr :"", har : ""}]
    const [updatevalrange, setUpdatevalrange] = useState(false)
    const [fib , setFib] = useState(false)
    const [{alt, src}, setImg] = useState({
        src: dp,
        alt: ''
      });
      const [filenames, setFilenames] = useState()
      
      useEffect(() => {
        dispatch(featureFetch())
      },[])

      
      const cinputConfirmAlert = (xcc) => {
        let mtext = ""
        if(features.featureCode === "" && categories.categoryCode !== ""){
            //Create new feature
            mtext ="Create new feature"
            props.swal({
              title: "Are you sure?",
              text: "Are you sure that you want to create feature?",
              icon: "warning",
              dangerMode: true,
            })
            .then(willDelete => {
              if (willDelete) {
                createFeature()
              }
            });
         
        }else if(features.featureCode !== "" && categories.categoryCode !== ""){
 //Create new feature
            mtext ="Update feature"
            props.swal({
              title: "Are you sure?",
              text: "Are you sure that you want to update feature?",
              icon: "warning",
              dangerMode: true,
            })
            .then(willDelete => {
              if (willDelete) {
                createFeature()
              }
            });
           
        }
       
      };  

      const dinputConfirmAlert = (categoriesCode, featureCode) => {
       
    
            if(!showvr){
                let mtext = "delete feature"
                swal({
                  title: "Are you sure?",
                  text: "Are you sure that you want to delete?",
                  icon: "warning",
                  dangerMode: true,
                })
                .then(willDelete => {
                  if (willDelete) {
                    dellFeature(categoriesCode, featureCode) 
                  }
                });
               
            }else{
                let mtext = "delete Value"
                swal({
                  title: "Are you sure?",
                  text: "Are you sure that you want to delete value?",
                  icon: "warning",
                  dangerMode: true,
                })
                .then(willDelete => {
                  if (willDelete) {
                    dellFeature(categoriesCode, featureCode) 
                  }
                });
            }
            
        
       
      };
    
      const createFeature = () => {
        console.log("Creating feature")
        if(fieldvalidator(features.en, categories.categoryCode)){
          props.swal("Some Required information is missing, check English name and code for categories.")
           return}
          setShowProcessing(true)
          console.log(features)
         
            let nft = {ar : features.ar , en : features.en , featureCode : features.featureCode, categoryCode : features.categoryCode, ico : features.ico, unit : features.unit , valueRange : features.valueRange}
          let formData = new FormData(); 
          formData.append("featurelogo" , filenames)
          formData.append("categories", JSON.stringify(categories) );
          formData.append("features", JSON.stringify(nft) );
          props.API({
            method: "post",
            url : `tenant/createfeature`,
            data: formData,
            headers : {"arixauth" : localStorage.getItem("arixauth")}
            }).then((res) => {
              props.swal("Feature Updated!")
              setShowProcessing(false)
              window.location.reload(false)
            //  window.location.reload(false)
            }).catch(function (error) {
              setShowProcessing(false)
              console.log(error)
              if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
              }
        })
          
           
  
      }

      const updImg = (e) => {
      /**  console.log(features.featureCode)
        
       if(features.featureCode !== ""){
       setShowProcessing(true)
        let formData = new FormData(); 
        formData.append("featurelogo" , e.target.files[0])
        formData.append("categories", JSON.stringify(categories) );
        formData.append("features", JSON.stringify(features) );
        
        props.API({
          method: "post",
          url : `tenant/fimageupd`,
          data: formData,
          headers : {"arixauth" : localStorage.getItem("arixauth")}
          }).then((res) => {
          //  props.swal("Feature Updated!")
            setShowProcessing(false)
            window.location.reload(false)
        //    dispatch(featureFetch())
        //    window.location.reload(false)
          }).catch(function (error) {
            setShowProcessing(false)
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }
      })
       }else{
        console.log("Feature code is " + features.featureCode)
       }
        */
      }

      const createRv = () => {
        
        if(updatevalrange){
          
            let newlen = valrange.len.replace(/^0+/, '')
            console.log(newlen)
            featuresList.find(fl => fl.featureCode === features.featureCode).valueRange.find(c => c.vrid === valrange.vrid).len = newlen
            featuresList.find(fl => fl.featureCode === features.featureCode).valueRange.find(c => c.vrid === valrange.vrid).hen = valrange.hen
            setShowProcessing(true)
         
            props.API.post(`tenant/updrv`, {categories : categories , features : featuresList , valrange : [], fib : fib },{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                //  window.location.reload(false)
                  props.swal(res.data.message)
                  setShowProcessing(false)
                  window.location.reload(false)
                  setShowvr(false)
               }).catch(function (error) {
                setShowProcessing(false)
                   console.log(error)
                   if(error.response.status === 401){
                    props.swal("Unauthorized, please login again.").then(t => {
                        props.history.push(`/auth/login`)
                    })   
                    }
                   setShowvr(false)
               }) 


        }else if(!updatevalrange){
          let newlen = valrange.len.replace(/^0+/, '')
          if(!fib){
            if( valrange.len === "" ||  valrange.len === undefined ){
              
              return 
            }
            if(features.valueRange.find(o => o.len === valrange.len)){
              return
            }
          }
            

            let maxnumber = 0
            
            if(features.valueRange.length >=1 && fib === false) {
                maxnumber =  Math.max(...features.valueRange.map(o => Number(o.vrid))) + 1 
            }
            let newvalr = {vrid : String(maxnumber) , len : newlen, lfr : "", lar : "", hen : valrange.hen, hfr :"", har : "" , fib : false} 
            setValRange({vrid : String(maxnumber) , len : newlen, lfr : "", lar : "", hen : valrange.hen, hfr :"", har : "", fib : false}) 

      
            let newf = {...features , actions : ""}
            newf.valueRange.push(newvalr)
            setShowProcessing(true)
            setFeatures(newf)
            
            //setFeatureslist(featuresList.push(newf))
            props.API.post(`tenant/createrv`, {categories : categories , features : newf,  valrange : [] , fib : fib},{ headers :{"arixauth" : localStorage.getItem("arixauth")}})
            .then((res) => {
              setShowProcessing(false)
                //  window.location.reload(false)
                //  props.swal(res.data.message)
                //dispatch(featureFetch())
                window.location.reload()
                setShowvr(false)
               }).catch(function (error) {
                setShowProcessing(false)
                   console.log(error)
                 //  props.swal("Error configuring City")
               }) 

        }
        setFib(false)
      }
    
      const dellFeature = (categoriesCode, featureCode) => {
        setShowProcessing(true)
        props.API.post(`tenant/delfeature`, {categoriesCode , featureCode},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            // window.location.reload(false)
             props.swal(res.data.message)
        //     dispatch(featureFetch())
             setShowProcessing(false)
             window.location.reload(false)
          }).catch(function (error) {
            setShowProcessing(false)
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              props.swal("Error deleting feature data.")
            }
              
          }) 
      }
   
      const dellValue = (vuid) => {

        let newfeatures = {...features , valueRange : vuid, actions : ""}
        setShowProcessing(true)
        //console.log(features)
       props.API.post(`tenant/delfvalue`, {categories : categories ,features : newfeatures}, { headers :{"arixauth" : localStorage.getItem("arixauth")}})
        .then((res) => {
      //   window.location.reload(false)
            props.swal(res.data.message).then(x => {
              window.location.reload(false)
              
            })
            setFvrl(vuid)
            setShowProcessing(false)
            
            
         }).catch(function (error) {
          setShowProcessing(false)
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              props.swal("Error deleting feature data.")
            }
             
        }) 
      }
   


      const showfvrl = () => {
        try{
            
            return (
                fvrl.map((e,key) => {
                    return (
                        <tr id={key}>
                            <td style={{textAlign : "center"}}>{e.vrid}</td>
                            <td style={{textAlign : "center"}}>{e.len}</td>
                          {/**   <td style={{textAlign : "center"}}>{e.hen}</td>*/} 
                           <td style={{textAlign : "center"}}>
                            <div className="actions-right">
                                    
                                    <Button
                                    onClick={() => {
                                        let obj = fvrl.find((o) => o.vrid === e.vrid);
                                        setValRange(obj)
                                        setUpdatevalrange(true)
                                    }}
                                    color="danger"
                                    size="sm"
                                    className="btn-icon btn-link remove"
                                    >
                                     <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                    </Button>{" "}
                                </div>

                            </td>
                          {/**  <td>{e.hen}</td>  */}
                            <td style={{textAlign : "center"}}>
                              
                                <div className="actions-right">
                                
                                    <Button
                                    onClick={() => {
                                        //let obj = fvrl.find((o) => o.vrid === e.vrid);
                                        let obj = fvrl.filter((o) => o.vrid !== e.vrid);
                                        dellValue(obj)
                                 
                                    }}
                                    color="danger"
                                    size="sm"
                                    className="btn-icon btn-link remove"
                                    >
                                    <i className="fa fa-times" />
                                    </Button>{" "}
                                </div>
                               

                            </td>
                        </tr>
                    )
                })
            )
        }catch(e){
              //  console.log(e)
        }
       
      }

      const changefib = (dv) => {
        console.log("changing fib from " + dv )
        setFib(!dv);
        setFeatures({...features, fib : !dv});
      }

      // this model alow you view and update value range for features..
      const valueRange = () => {
        let isdis = features.fib
        //setFib(features.fib)
        return(
            <Modal isOpen={showvr}>
                <ModalHeader >
                  <Row><Col>{features.featureCode}-{features?.en}</Col><Col ><i className="fa fa-close" style={{cursor : "pointer", float : "right"}} onClick={() => setShowvr(!showvr)} /></Col></Row>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Row>
                                <Col> <Switch 
                                offColor="primary"  
                                offText="Val"
                                onColor="primary"
                                onText="Bool"
                                onChange = {x => {changefib(features.fib);}}
                                value={features.fib}
                              /></Col>
                                <Col><label style={{marginTop  :5}}>Value : </label></Col>
                                <Col><Input type = "text" placeholder="Min" value={valrange.len} maxLength={3} readOnly={isdis}
                                      onChange={x => {
                                        
                                        setValRange({...valrange, len : numtest.test(x.target.value) ? x.target.value: "1"})
                                      }}
                                /></Col>
                               {/**  <Col><Input type = "text" placeholder="Max" value={valrange.hen}
                                 onChange={x => {
                                    setValRange({...valrange, hen : x.target.value})
                                  }}
                                  /></Col> */}
                                <Col><Button size="sm" style={{marginTop  : 2}} onClick={g => {createRv()}}> {updatevalrange ? "Update" : "Add"}</Button></Col>
                            </Row>
                        </Col>
                    </Row>
                <Row>
                    <Col>
                    <Table style={{fontSize : "1rem"}}>
                    <thead>
                        <tr>
                        <th style={{textAlign : "center"}}>#</th>
                        <th style={{textAlign : "center"}}>Value</th>
                        {/** <th>Higher</th> 
                        <th style={{textAlign : "center"}}>Max</th>*/}
                        <th ></th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                            {
                            showfvrl()
                            }
                    </tbody>
                    </Table>
                    </Col>
                </Row>
                </ModalBody>
            </Modal>
        )
        
      }
  
     

      const handleClick = event => {
        hiddenFileInput.current.click();

      };
    
      const handleImg = (e) => {
        
        if(e.target.files[0]) {
                
            if(filenamevalid(e.target.files[0])){
              setFilenames(e.target.files[0])
              setImg({
                src: URL.createObjectURL(e.target.files[0]),
                alt: e.target.files[0].name
            });
            updImg(e)
            }else{
              props.swal("Invalid Filename")
            }
            
        
        }   
    }
    
     return (
      
        <div className="content">
             
             {showProcessing && props.Spin}
             {valueRange()}
             <input
                ref={hiddenFileInput}
                type="file" 
                accept=".png, .jpg, .jpeg" 
                id="photo" 
                className="visually-hidden"
                onChange={e=> handleImg(e)}
                hidden/>

        <Row>
            {/** This will contain Table */}
            <Col sm="12" md="5">
             
             <Card>
                 <CardHeader>
                 <Row>
                         <Col >
                         <FormGroup>
                               <label>Select Catagory </label>
                                     <Select options={catlist} styles={customStyles} 
                                            value={{label : categories.en + ' ' + categories.ar, value : categories.categoryCode}} 
                                            onChange={e=> {
                                                    setCategories({categoryCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar});
                                                    setFeatureslist(e.features.map(t => {
                                                        return {
                                                        ...t, value : t.featureCode, label: t.en, labelfr: t.fr, labelar : t.ar , unit : t.unit, fib : t.fib
                                                        }
                                                    }));  
                                                    setFeatures({featureCode : "", en : "", fr : "", ar : "", unit : "", fib : false})      
                                                    }}
                                            />
                               
                         </FormGroup>
                      
                         </Col>
                 </Row>
              
                 <Row>
                    <Col>
                    <FormGroup>
                         <label>Features</label>
                                 <Select options={featuresList} styles={customStyles} 
                                   value={{label : features.en + ' '+  features.ar , value : features.categoryCode}} 
                                   onChange={e=> {setFeatures({featureCode: e.value, en: e.label, fr: e.fr, ar: e.ar, unit : e.unit, ficon : e.ficon, fib : e.fib}) 
                                                   setImg({
                                                    src: `${e.ficon}`,
                                                    alt : "..."
                                                   }) 
                                }}
                                  
                                   />
                         </FormGroup>
                    </Col>
                 </Row>
                
               <Row>
                <Col>
                <h6 style={{marginTop : 10}} >Feature {features.featureCode !== "" && " Code : " +  features.featureCode} </h6> 
                </Col>
               <Col>
               <span style={{float : "right"}}>
                          {features?.en && <img
                                    alt="..."
                                    width={"40px"}
                                    src={src}
                                    style={{ cursor : "pointer"}} 
                                    onClick={e => {
                                        handleClick(e)
                                    }}
                                />
                           }
                 </span>
               </Col>
               </Row>
                 
                
                 <Row >
                        <Col className="pr-1" md="4">
                        <FormGroup>
                             <label>Unit</label>
                             <Input
                             value={features.unit}
                             placeholder="en"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , unit : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                         <Col className="pr-1" md="4">
                      
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                             value={features.en}
                             placeholder="en"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , en : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                         {/**  <Col className="pr-1" md="3">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                              value={features.fr}
                             placeholder="Nom"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , fr : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>*/}
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label style={{float : "right"}}>اسم</label>
                             <Input
                              value={features.ar}
                             placeholder="اسم"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , ar : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                 </Row>
             
                 </CardHeader>
                 <CardBody>
               
                 </CardBody>
                 <CardFooter>
                   
                     <Button size="sm" color="primary" onClick={x => {setFeatures({featureCode : "", en : "", fr : "", ar : "", fib : false});}} >New Feature</Button>
                     <Button size="sm" color="warning" style={{float : "right"}} onClick={x => {
                        cinputConfirmAlert()
                     }}>Update</Button>
                 </CardFooter>
             </Card>
         </Col>
         <Col sm="12" md="7">
               <ReactTables featuresList={featuresList} categories={categories} 
               dellFeature={dinputConfirmAlert} setFvrl={setFvrl} 
               setShowvr={setShowvr} setSelectedfvrl={setSelectedfvrl}
               setFeatures={setFeatures}
               />
            </Col>
           
        </Row>
        </div>
    )
}

export default Features;